import React from 'react'
import { NavLink,useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
  CImage
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { ContHeaderProfile,ContHeaderSub } from './index'
import { UFunc } from '../helpers/functions'

const pjson = require('../../package.json');
const ContHeader = (props) => {
	const { setToken,setLoading, showToast } = props 

	const uDispatch 	= useDispatch()
	const uNavigate 	= useNavigate()
	const uSidebarshow 	= useSelector((state) => state.sidebarShow)
	const uBahasaObj  	= useSelector(state => state.listBahasa)
	const uTokenobj		= JSON.parse(localStorage.getItem("token")||"{}");
	const uActiveroute	= useSelector(state => state.activeRoute)
	//const [uEfekview,setEfekview] 	= React.useState(false);

	//console.log("(ContHeader) uSidebarshow => "+uSidebarshow)
	return (
		<CHeader position="sticky" className="mb-4 p-0" style={{borderBottomColor:"#ebebeb"}}>
		<CContainer fluid className="classheadertop" style={{minHeight:64}}>
			<CHeaderToggler onClick={() => {
					uDispatch({ type: 'set', sidebarShow: !uSidebarshow });
				}}
				className="px-0 me-2">
			<CIcon icon="cilMenu" className="align-middle" height={25}/>
			</CHeaderToggler>

			{(uActiveroute||"").toUpperCase()==="DASHBOARD" 
				|| (uBahasaObj["menus_"+(uActiveroute||"")]||"") === ""
			? (
			<CHeaderBrand className="d-md-none me-auto text-normal" 
				onClick={()=>uNavigate("/dashboard")}>
				<div className="classfontbrand fs-2">
				{(()=>{
					const vNameArr = pjson.name.split("tor");
					return (
					<>
					{vNameArr[0]}
					t<CIcon className="classikon classikonlogo" height={25}/>r
					{vNameArr[1]}
					</>
					)
				})()}
				</div>
			</CHeaderBrand>
			) : (
			<CHeaderNav className="d-md-none me-auto text-normal" 
				onClick={()=>uNavigate("/dashboard")}>
				<b>{uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]||""}</b>
			</CHeaderNav>
			)}
			
			<CHeaderNav className="d-none d-md-block me-auto text-normal classcursorpointer"
				onClick={()=>uNavigate("/dashboard")}>
				<b className="d-md-none d-lg-block">Hi, {UFunc.Usercaptionfilter(uTokenobj.usercaption)}</b>
				<b className="d-lg-none">{UFunc.Usercaptionfilter(uTokenobj.usercaption)}</b>
			</CHeaderNav>

			<CHeaderNav className="align-items-center">
				<ContHeaderProfile {...props}/>
			</CHeaderNav>
		</CContainer>

		<ContHeaderSub {...props}/>
		</CHeader>
	)//>
}

export default ContHeader

	